import { useEffect } from "react";

import { Column, TopbarContainer, TopbarTitle } from "@/components";
import { OrphanedWorkableJobs } from "@/components/orphaned-workable-jobs/OrphanedWorkableJobs";

import { useSetTitle } from "@/hooks/useSetTitle";
import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_SCREENS } from "@/lib/mixpanel/types";

export const OrphanedWorkableJobsPage = () => {
  useSetTitle({
    title: "Orphaned Workable Jobs",
  });

  useEffect(() => {
    mixpanelUtils.trackScreenView(MIXPANEL_SCREENS.ORPHANED_WORKABLE_JOBS);
  }, []);

  return (
    <Column className="h-svh">
      <TopbarContainer>
        <TopbarTitle>Orphaned Workable Jobs</TopbarTitle>
      </TopbarContainer>
      <OrphanedWorkableJobs />
    </Column>
  );
};
